import { Component } from '@angular/core';

@Component({
  selector: '[app-noc-footer]',
  templateUrl: './noc-footer.component.html',
  styleUrls: ['./noc-footer.component.css']
})
export class NocFooterComponent {

}
